import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import { Grid, Paper, Typography } from "@mui/material";

import dayjs from "dayjs";

import actions from "../../../../store/actions";
import ls from "../../../../Localization";

import { State } from "store/reducers";
import { BankBilletDetailState } from "store/reducers/bankBillet/detail";
import useStyles from "./styles";
import { BankBilletStatus } from "Types/BankBillet";
import { toStringCurrency } from "helpers/string";

import Splits from "./Splits";

export function BankBilletDetail({
	match: {
		params: { id }
	}
}: any) {
	const classes = useStyles({});
	const dispatch = useDispatch<any>();

	useEffect(() => {
		dispatch(actions.bankBillet.detail.clearValues());
		dispatch(actions.bankBillet.detail.getBankBillet(id));
	}, [dispatch, id]);

	const { item } = useSelector<State, BankBilletDetailState>(
		s => s.bankBilletDetail
	);

	if (!item) return null;

	const {
		createdAt,
		status,
		referenceNumber,
		name,
		value,
		email,
		street,
		number,
		complement,
		neighborhood,
		city,
		state,
		zipCode,
		url,
		description
	}: any = item;

	const ls2: any = ls;

	return (
		<Grid container justifyContent="center" spacing={5}>
			<Grid item xs={11}>
				<Paper className={classes.root}>
					<div className={classes.header}>
						<Typography variant="h6">{ls.bankBilletData}</Typography>
						<div>
							{/* <Button color="primary" onClick={handleEdit}>
								{ls.edit}
							</Button> */}
						</div>
					</div>
					<hr className={classes.line} />

					<Grid container spacing={2} className={classes.form}>
						<Grid item xs={12} sm={6} md={4} lg={3}>
							<strong>{ls.creationDate}</strong>:{" "}
							{dayjs(createdAt).format(ls.dateFormatWithoutSeconds)}
						</Grid>

						<Grid item xs={12} sm={6} md={4} lg={3}>
							<strong>Nº Documento</strong>: {referenceNumber}
						</Grid>

						<Grid item xs={12} sm={6} md={6} lg={5}>
							<strong>{ls.name}</strong>: {name}
						</Grid>

						<Grid item xs={12} sm={6} md={4} lg={3}>
							<strong>{ls.email}</strong>: {email}
						</Grid>

						<Grid item xs={12} sm={6} md={4} lg={3}>
							<strong>{ls.value}</strong>: {toStringCurrency(+value / 100.0)}
						</Grid>

						<Grid item xs={12} sm={6} md={4} lg={3}>
							<strong>{ls.status}</strong>: {ls2[BankBilletStatus[status]]}
						</Grid>

						<Grid item xs={12}>
							<strong>{ls.address}</strong>:{" "}
							{`${street ?? ""}, ${number ?? ""} - ${complement ?? ""} - ${
								neighborhood ?? ""
							} - ${city ?? ""} - ${state ?? ""} - ${zipCode ?? ""}`}
						</Grid>

						<Grid item xs={12}>
							<strong>Descrição</strong>: {description}
						</Grid>

						<Grid item xs={12}>
							<strong>Link</strong>:{" "}
							<a href={url} target="_blank">
								Abrir em nova guia
							</a>
						</Grid>
					</Grid>
				</Paper>
			</Grid>
			<Grid item xs={11}>
				<Splits id={id} />
			</Grid>
		</Grid>
	);
}

export default BankBilletDetail;
